import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=756bebe6&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=ts"
export * from "./KanbanBoard.vue?vue&type=script&lang=ts"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=756bebe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756bebe6",
  null
  
)

export default component.exports